import React from "react";
import { Dropdown, Container, Row, Col } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";

import logoLight from "../Logo-light.svg";
import { auth, useUser } from "../firebase";
import StorageImage from "../components/StorageImage";
import DangerBar from "../components/DangerBar";

const Navbar = ({ menuList, history }) => {
  const { user, refresh } = useUser();
  return (
    <>
      <DangerBar />
      <div className="header">
        <Container className="h-100">
          <Row className="h-100 flex-nowrap justify-content-between align-items-center">
            <Col>
              <Link to="/">
                <img src={logoLight} alt="logo" height="22" />
              </Link>
            </Col>
            <div className="col d-flex justify-content-end align-items-center">
              {user ? (
                <Dropdown alignRight>
                  <Dropdown.Toggle
                    variant="outline"
                    className="text-light d-flex align-items-center"
                  >
                    <StorageImage
                      className="avatar-sm mr-2"
                      alt="profile"
                      update={refresh}
                      path={`profile/${user.uid}.png`}
                    />
                    <span className="d-none d-md-block mr-1">{user.displayName}</span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Header>{user.displayName}</Dropdown.Header>
                    <Link to="/edit" className="dropdown-item">
                      Edit Profile
                    </Link>
                    <Link to="/change-password" className="dropdown-item">
                      Change Password
                    </Link>
                    <Dropdown.Divider />
                    <Link to="/delete-user" className="dropdown-item text-danger">
                      Delete User
                    </Link>
                    <Dropdown.Divider />
                    <button
                      className="dropdown-item text-danger"
                      onClick={() => {
                        auth().signOut();
                        history.push("/");
                      }}
                    >
                      Logout
                    </button>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <Link to="/login" className="btn btn-sm btn-outline-light">
                  Login
                </Link>
              )}
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default withRouter(Navbar);
